// myfrontend/src/components/PetForm.js
import React, { useState, useEffect  } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { useLocation } from 'react-router-dom';
import '../static/form.css';
import '../static/modals.scss';
import '../static/SignaturePad.css'; 
import TermsModal from './TermsModal'; 

const PetForm = () => {
    const [name, setName] = useState('');
    const [breed, setBreed] = useState('');
    const [catdog, setCatdog] = useState('');
    const [owner, setOwner] = useState(''); // Assume you're passing owner ID
    const [phone, setPhone] = useState('');
    const [gender, setGender] = useState('');
    const [age, setAge] = useState('');
    const [behaviour, setBehaviour] = useState('');
    const [allergies, setAllergies] = useState('');
    const [vaccinated, setVaccinated] = useState(false);
    const [neutered, setNeutered] = useState(false);
    const [groomingHistory, setGroomingHistory] = useState('');
    const [socialMediaConsent, setSocialMediaConsent] = useState(false);
    const navigate = useNavigate();
    const location = useLocation();
    const ownerData = location.state?.owner;
    useEffect(() => {
        if (ownerData) {
            setOwner(ownerData.id);
            setPhone(ownerData.phone);
             
           
        }
    }, [ownerData]);
const handleSubmit = async (e) => {
    e.preventDefault();
    const formData = new FormData();
    formData.append('name', name || 'Unknown');
    formData.append('breed', breed || 'Unknown');
    formData.append('catdog', catdog || 'Unknown');
    formData.append('owner', owner || 'Anonymous');
    formData.append('phone', phone || '0000000000');
    formData.append('gender', gender || 'Unknown');
    formData.append('age', age || '0');
    formData.append('behaviour', behaviour || 'Not specified');
    formData.append('allergies', allergies || 'None');
    formData.append('vaccinated', vaccinated ? 'true' : 'false');
    formData.append('neutered', neutered ? 'true' : 'false');
    formData.append('grooming_history', groomingHistory || 'No history');
    formData.append('social_media_consent', socialMediaConsent ? 'true' : 'false');

    try {
        const response = await axios.post('/create-pet/', formData, {
            headers: { 'Content-Type': 'multipart/form-data' }
        });
        const petData = response.data;
        
        if (!petData || !petData.id) {
            alert('Pet creation failed or pet data incomplete');
            return;
        }

        alert('Pet created successfully:');
        console.log('Pet created successfully:', petData);

        // ✅ Navigate to PetForm.js and pass owner data
        navigate('/signit', {
            state: {
                owner: {
                    pet: response.data.pet_id,
                    phone: response.data.phone,
                    owner: response.data.email
                }
            }
        });

        // Clear form
        setName('');
        setBreed('');
        setCatdog('');
        setOwner('');
        setPhone('');
        setGender('');
        setAge('');
        setBehaviour('');
        setAllergies('');
        setVaccinated(false);
        setNeutered(false);
        setGroomingHistory('');
        setSocialMediaConsent(false);
    } catch (error) {
        console.error('Error:', error.response?.data);
    }
};

    return (
        <section className="contact-wrap">
        <form onSubmit={handleSubmit} className="contact-form" encType="multipart/form-data">
           <label>Name:</label>
            <div className="input-block"> 
                <input type="text" value={name} onChange={(e) => setName(e.target.value)} required className="form-control" />
            </div>
            <label>Breed:</label>
            <div className="input-block">
                
                <input type="text" value={breed} onChange={(e) => setBreed(e.target.value)} required className="form-control" />
            </div>
          <label>Type (Cat/Dog):</label>
            <div className="input-block">
         <select value={catdog} onChange={(e) => setCatdog(e.target.value)} className="form-control">
            <option value="">Select</option>
            <option value="Cat">Cat</option>
            <option value="Dog">Dog</option>
            </select>
            </div>

           
            <div className="input-block">
                <label>Owner ID:</label>
                <input type="hidden" value={owner} onChange={(e) => setOwner(e.target.value)}  className="form-control"   />
            </div>

            <label>Phone:</label>
            <div className="input-block">
                
                <input type="hidden"   value={phone} onChange={(e) => setPhone(e.target.value)}  className="form-control" />
            </div>

           <label>Gender:</label>
            <div className="input-block">
                
                <select value={gender} onChange={(e) => setGender(e.target.value)} className="form-control" >
                    <option value=" ">Select</option>
                    <option value="Male">Male</option>
                    <option value="Female">Female</option>
                </select>
            </div>

            <label>Age:</label>
            <div className="input-block">
                
                <input type="number" value={age} onChange={(e) => setAge(e.target.value)}  className="form-control" />
            </div>

            <label>Behaviour:</label>
            <div className="input-block">
             <select value={behaviour} onChange={(e) => setBehaviour(e.target.value)} className="form-control">
                    <option value="">Select</option>
                    <option value="🆕 New">🆕 New</option>
                    <option value="😠 Aggressive">😠 Aggressive</option>
                    <option value="😊 Gentle">😊 Gentle</option>
                    <option value="😳 Shy">😳 Shy</option>
                    <option value="🤪 Excited">🤪 Excited</option>
                    <option value="😴 Tired">😴 Tired</option>
                    <option value="😌 Calm">😌 Calm</option>
                    <option value="😨 Fearful">😨 Fearful</option>
                    <option value="Naughty behavior"> Naughty behavior</option>
                </select>
            </div>

            <label>Allergies:</label>
                 <div className=" ">
                    <textarea  value={allergies} onChange={(e) => setAllergies(e.target.value)} className="textarea"  rows={10}
  cols={30} />
                </div>
 
            <label>Vaccinated:</label>
            <div  >
                
                <input type="checkbox" className="form-control" checked={vaccinated} onChange={(e) => setVaccinated(e.target.checked)} />
            </div>

            <label>Neutered:</label>
            <div  >
                
                <input type="checkbox" className="form-control" checked={neutered} onChange={(e) => setNeutered(e.target.checked)} />
            </div>

            <label>Grooming History:</label>
            <div className=" ">
                
                <textarea value={groomingHistory} onChange={(e) => setGroomingHistory(e.target.value)}  className="textarea"  rows={10}
  cols={30}  />
            </div>

            <label>Consent to Share on Social Media:</label>
            <div className="input-block">
                
                <input type="text" className="form-control" checked={socialMediaConsent} onChange={(e) => setSocialMediaConsent(e.target.checked)} />
            </div>
           <TermsModal />
            <label>
  <input
    type="checkbox"
    checked={vaccinated}
    onChange={(e) => setVaccinated(e.target.checked)}
    title="Agree"
    required
  />
  I agree to the vaccination terms
</label>

            <button type="submit" className="square-button"> Submit Pet Info
            </button>
        </form>
        </section>
    );
};

export default PetForm;
